export default __webpack_public_path__ + "static/media/hero-img.e257727d.png";